import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrNotificationChannel.ts
var t = () => e("notificationChannel");
//#endregion
export { t as useTrNotificationChannel };
